import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "textpatheffects"
    }}>{`TextPathEffects`}</h1>
    <p>{`Options for the alignment and appearance of type on a path.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RAINBOW_PATH_EFFECT`}</strong>{` = 1601201778`}</p>
      <p parentName="blockquote">{`The center of each character's baseline is parallel to the path's tangent. This is the default effect.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SKEW_PATH_EFFECT`}</strong>{` = 1601201779`}</p>
      <p parentName="blockquote">{`The text characters' vertical edges are perfectly vertical regardless of the path shape.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RIBBON_PATH_EFFECT`}</strong>{` = 1601201715`}</p>
      <p parentName="blockquote">{`The text characters' horizontal edges are perfectly horizontal regardless of the path shape.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`STAIR_STEP_PATH_EFFECT`}</strong>{` = 1601205107`}</p>
      <p parentName="blockquote">{`The left edge of each character's baseline is on the path and no characters are rotated.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GRAVITY_PATH_EFFECT`}</strong>{` = 1601201767`}</p>
      <p parentName="blockquote">{`The center of each character's baseline is on the path while each vertical edge is in line with the path's center point.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      